import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toastConfig } from "config"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { updateTicketFetch } from "store/middlewares/tickets.crud"
import { queryClient as qc, ticketStatuses } from "keys"
import { app } from "router/routes"
import { useContext } from "react"
import { TicketContext } from "../TicketContext"

const useToBeDeveloped = () => {
    const params = useParams()
    const queryClient = useQueryClient()
    const navigate = useNavigate()

    const { ticket } = useContext(TicketContext)

    const { mutateAsync: updateToBeDevelopedStatus } = useMutation({
        mutationFn: () => updateTicketFetch({ id: params.ticketID, status: ticketStatuses.TO_BE_DEVELOPED }),
        onSuccess: () => {
            toast.dismiss()
            toast("הפנייה התעדכנה", toastConfig)
            queryClient.invalidateQueries([qc.ticket])
            navigate(app.tickets)
        }
    })

    const toBeDevelopedTicketBtn = {
        systemUI: false,
        fullWidth: true,
        color: "dark",
        disabledColor: "gray2",
        label: "לפיתוח",
        role: "create",
        feature: "to-be-developed",
        permissionHOC: "disabled",
        disabled: ticket.data?.status === ticketStatuses.TO_BE_DEVELOPED,
        action: updateToBeDevelopedStatus
    }

    return toBeDevelopedTicketBtn
}

export default useToBeDeveloped